import React from "react";
import NumberFormat from 'react-number-format';
import { Row, Col, Select } from 'antd';

const InvoicePaymentTimePicker = props => {
  const { setTimeObject = () => {}, timeObject = {}} = props
  return (
    <Row className="mt-10">
      <Col flex={0}>
        <NumberFormat 
          className="ant-input ant-input-lg" 
          displayType={'input'} 
          thousandSeparator={true} 
          style={{ width: 60 }}
          decimalScale={0} 
          placeholder={"#"}
          value={timeObject.time_value} 
          onChange={(e) => setTimeObject({ ...timeObject, time_value: e.target.value})}
        />
      </Col>
      <Col flex={0}>
        <Select
          style={{ width: 100 }}
          placeholder={"Select"}
          size='large'
          value={timeObject.time_unit}
          onChange={(value) => setTimeObject({ ...timeObject, time_unit: value})}
        >
          <Select.Option value="DAYS">days</Select.Option>
          <Select.Option value="WEEKS">weeks</Select.Option>
        </Select>
      </Col>
      <Col flex={1}>
        <Select
          style={{ width: '100%' }}
          placeholder={"Select"}
          size='large'
          value={timeObject.time_period}
          onChange={(value) => setTimeObject({ ...timeObject, time_period: value})}
        >
          <Select.Option value="AFTER_ISSUE_DATE">after issue date</Select.Option>
          <Select.Option value="BEFORE_EVENT_DATE">before event date</Select.Option>
          <Select.Option value="AFTER_EVENT_DATE">after event date</Select.Option>
        </Select>
      </Col>
    </Row>
  );
};

export default InvoicePaymentTimePicker;
